import { Theme } from '@material-ui/core';
import { Styles } from '@material-ui/core/styles/withStyles';
import { colors } from 'theme';

export type ListStyleProps = {
  columnWidth: string;
  paddingLeft?: string;
  paddingRight?: string;
};

export const LISTS_COMMON_STYLES: Styles<Theme, ListStyleProps> = {
  table: {
    minWidth: '20rem',
  },
  cell: {
    width: ({ columnWidth }) => columnWidth,
    textAlign: 'left',
    paddingLeft: ({ paddingLeft }) => paddingLeft,
    paddingRight: ({ paddingRight }) => paddingRight,
  },
  monthYearCell: {
    textTransform: 'capitalize',
  },
  centeredCell: {
    textAlign: 'center',

    '& svg': {
      marginRight: '-18px',
    },
  },
  rightAlignedCell: {
    textAlign: 'right',
    flexDirection: 'row-reverse',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > *:not(:last-child)': {
      marginRight: '3px',
    },
    '& > *:not(:first-child)': {
      marginLeft: '3px',
    },
    '& button': {
      padding: '0.5rem',
      minWidth: 'initial',
    },
    '& a': {
      minWidth: 'initial',
    },
  },
  moreActionButton: {
    width: '0px',
  },
  chipsConfigured: {
    borderRadius: '4px',
    textAlign: 'center',
    fontWeight: 400,
    color: colors.white,
    padding: '10px',
  },
};
